import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { findDashboardLeaf } from '@cumlaude/shared-dashboard-registry';
import { stripQueryParams } from '@cumlaude/shared-services';
import { FilteringTekstService } from '../../../services/filtering-tekst.service';

@Component({
	selector: 'app-pagina-card',
	templateUrl: './pagina-card.component.html',
	styleUrls: ['./pagina-card.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginaCardComponent {
	private readonly filteringTekstService = inject(FilteringTekstService);

	url = input.required<string>();
	titel = input<string>();
	bovenschrift = input<string>();

	clickit = output<void>();

	private readonly pad = computed(() => stripQueryParams(this.url()));

	private readonly dashboardLeaf = computed(() => findDashboardLeaf(this.pad()));

	weergaveTitel = computed(() => this.titel() ?? this.dashboardLeaf()?.naam ?? '');

	hoofdpagina = computed(() => this.dashboardLeaf()?.hoofdpagina);

	filteringTekst = computed(() => this.filteringTekstService.bepaalFilteringTekst(this.url()));
}
